// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { memo, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { css } from 'styled-components';
export var StaticPortal = memo(function (_a) {
    var children = _a.children, style = _a.style;
    var el = document.createElement('div');
    el.setAttribute('id', 'root-portal');
    if (style) {
        el.setAttribute('style', css(style).join(''));
    }
    useEffect(function () {
        document.body.appendChild(el);
        return function () {
            document.body.removeChild(el);
        };
    }, []);
    return createPortal(children, el);
}, function () { return true; });
StaticPortal.displayName = 'StaticPortal';
